<template>
  <h2 class="title">{{ text }}</h2>
</template>

<script>
export default {
  name: 'SectionTitle',

  props: {
    text: {
      type: String,
      require: true
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
    padding-bottom: 60px;
    font-family: Oswald, sans-serif;
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: .06em;

    @media screen and (max-width: 722px) {
        padding-bottom: 40px;
    }

    @media screen and (min-width: 723px) and (max-width: 963px) {
    }

    @media screen and (min-width: 964px) and (max-width: 1523px) {
    }

    @media screen and (min-width: 1524px) and (max-width: 2286px) {
    }

    @media screen and (min-width: 2287px) {
    }
}
</style>
